module.exports = "<app-caste-verification-menu></app-caste-verification-menu>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/caste-verification/caste-verification.component.html
// module id = ./src/app/caste-verification/caste-verification.component.html
// module chunks = main